import { RoutemapMissedAlert } from '@/entities/alerts/card-missed';
import { Loader } from '@/shared/components/loader/loader';
import { RoutemapRequestError } from '@/entities/alerts/routemap-request-error';
import { useGetAllExecutorsQuery, useGetPreformTechMapByIdQuery } from '@/shared/state/api/swagger';

import { selectExecutorsForOptions } from '@/entities/employee';
import { useParams } from 'react-router-dom';
import { OperationFillFormPreform } from '@/widgets/operation';
import { RoutemapCloseAlert } from '@/entities/alerts';
import {
	PREFORM_TECHMAP_OPERATION_CLOSED_STATUSES,
	PREFORM_TECHMAP_OPERATION_ISSUE_DETAILS_STATUSES,
} from '../model/model';
import { IssueDetailsFormPreform } from '@/widgets/operation/ui';

export const PreformTechmapOperationPage = () => {
	const { preformTechMapId } = useParams();
	const {
		data: techMap,
		isError: isTechMapError,
		isLoading: isTechMapLoading,
		error: techMapError,
	} = useGetPreformTechMapByIdQuery({ preformTechMapId: Number(preformTechMapId) });
	const { options: employees = [], isLoading: isEmployeesLoading } = useGetAllExecutorsQuery(
		{ stringToSearch: '' },
		{
			selectFromResult: (result) => ({
				...result,
				options: selectExecutorsForOptions(result?.data),
			}),
		},
	);

	if (isTechMapError) {
		if ('status' in techMapError && techMapError.status === 461) {
			return <RoutemapMissedAlert />;
		}
		return <RoutemapRequestError />;
	}

	if (isTechMapLoading || !techMap?.status || !techMap?.number || isEmployeesLoading || !techMap?.id) {
		return <Loader />;
	}

	// Если МК закрыта
	if (PREFORM_TECHMAP_OPERATION_CLOSED_STATUSES.includes(techMap?.status)) {
		return <RoutemapCloseAlert variant="preform" productTechMapNumber={techMap?.number} />;
	}

	return (
		<div>
			{PREFORM_TECHMAP_OPERATION_ISSUE_DETAILS_STATUSES.includes(techMap?.status) && (
				<IssueDetailsFormPreform mappedEmployees={employees} techMap={techMap} />
			)}
			{techMap?.status === 'progress' && <OperationFillFormPreform techMap={techMap} employees={employees} />}
		</div>
	);
};
